<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-menu :class="$style.dropdown"
          offset-y>
    <template v-slot:activator="{ on }">
      <button :class="$style.headerLogin"
              v-on="on">
        <svg
          v-svg
          :class="$style.headerLoginIcon"
          symbol="account-icon"
        />
        <span :class="$style.headerText">
          <template v-if="isAuthenticated && !isGuest && authUser">
            {{ authUser.firstName }} {{ authUser.lastName }}
          </template>
          <template v-else>
            Join/Sign In
          </template>
        </span>
        <svg
          v-svg
          :class="$style.headerDownIcon"
          symbol="chevron-down"
        />
      </button>
    </template>
    <v-list :class="$style.dropdownMenu">
      <template v-if="isAuthenticated && !isGuest && authUser">
        <v-list-tile :class="$style.dropdownItem">
          <v-list-tile-title @click="openAccount">
            <a :class="$style.dropdownLink"
               href="#">My Account</a>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title @click="logout">
            <a :class="$style.dropdownLink"
               href="#">Log Out</a>
          </v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-else>
        <v-list-tile @click="login">
          <v-list-tile-title>
            <a :class="$style.dropdownLink"
               href="#">Login</a>
          </v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter, Mutation, Action } from 'vuex-class';
import { AUTH_MODAL, AUTH_LOGOUT } from '@/apps/auth/store/types';

/**
 * Dropdown to display user data.
 */
@Component({
  name: 'DesktopUserData',
})
export default class DesktopUserData extends Vue {
  @Getter isAuthenticated;
  @Getter authUser;
  @Getter isGuest;
  @Mutation(AUTH_MODAL) showModal;
  @Action(AUTH_LOGOUT) authLogout;

  /**
   * Mutate state to open signIn modal
   */
  login() {
    this.showModal({ name: 'signIn', value: true });
  }

  /**
   * Triggers state action to clear local storage and logout current user.
   */
  async logout() {
    await this.authLogout();
    this.$router.push({ path: '/' });
  }

  /**
   * Open the account page.
   */
  openAccount() {
    this.$router.push({ path: '/account' });
  }
}
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";
  .headerText {
    font-family: 'Gotham', sans-serif;
    font-size: 15px;
    font-weight: 300;
    letter-spacing: -0.36px;
    line-height: 20px;
    text-align: left;
    color: $white;
    margin: 0 10px;
  }

  .headerLogin {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-right: 24px;
    border-right: 1px solid $white-transparent;
    outline: none;
    .headerLoginIcon {
      width: 24px;
      height: 24px;
      fill: $white;
      opacity: 0.5;
    }
  }

  .headerDownIcon {
    width: 12px;
    height: 7px;
    fill: $white;
  }

  .userDropdown {
    background-color: $title-black
  }

  .dropdown {
    z-index: 30;
  }

  .dropdownMenu {
    border-top: 4px solid $green-color;
    /* Overriding Vuetify style */
    background-color: $white !important;
    margin-top: 15px;
  }

  .dropdownItem {
    height: 36px;
  }

  .dropdownLink {
    font-family: 'Gotham', sans-serif;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.21px;
    font-weight: 700;
    color: $black;
    text-decoration: none;
  }

  @media screen and (max-width: 900px) {
    .headerText,
    .headerDownIcon {
      display: none;
    }

    .headerLogin .headerLoginIcon {
      width: 32px;
      height: 32px;
    }
  }

  @media screen and (max-width: 530px) {

    .headerLogin,
    .headerStore {
      padding-right: 16px;
    }

    .headerCart {
      margin-right: 10px;
    }
  }


</style>

/* Overriding Vuetify style */
<style lang="scss">
.v-menu__content {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopUserData.vue